export const PERIOD_LIST = [
  {label: '上半年', value: 6.5},
  {label: '全年', value: 13.0},
];
export const PERIODS = {
  6.5: '上半年',
  13: '全年',
};
export const OEC_LEVEL = [
  {label: 'A'},
  {label: 'B'},
  {label: 'C'},
];

export const CLASSIFY_MAP = {
  0: 'ImportantKPI', // 重要KPI成绩
  10: 'Business', // 业务成绩
  20: 'BudgetAndCostControl', // 费效管理成绩
  30: 'HumanResource', // 人力资源管理成绩
  40: 'CorporateCultures', // 企业文化管理成绩

  100: 'ImportantKPI', // 绩效成绩
  110: 'CorporateCulture', // 企业文化导向成绩
  120: 'PersonalGrowth', // 个人成长成绩
  130: 'AVGOEC', // OEC综合成绩（参评月份的平均分）
};
export const EDITDABLE_CLASSIFY = [0, 10, 100, 110, 120]; // 折叠分类分数，可编辑修改的类别
export const MANAGE_EDITDABLE_CLASSIFY = [0, 10, 20, 30, 40, 100, 110, 120]; // 综合绩效管理 折叠分类分数，可编辑修改的类别


export const YEAR_PLAN_STATUS = {
  0: '已保存',
  10: '已引入',
  20: '上级已确认',
  30: '外部已确认',
  40: '已确认',
  50: '已公示',
};

// 考核表状态
export const WORK_SCORE = {
  0: '已保存',
  10: '已驳回',
  20: '已提交',
  30: '已通过',
  40: '评分已确认',
  50: '已公示',
};

// 考核表状态
export const WORK_SCORE_STATE = {
  0: '未填报',
  10: '未填报',
  20: '已填报',
  30: '已填报',
  40: '已填报',
  50: '已公示',
};

// 重要度、综合结果申报状态
export const IMPORTANCE = {
  0: '已保存',
  10: '已驳回',
  20: '已提交',
  30: '已审批',
  40: '已公示',
};
// 重要度、综合结果申报状态
export const IMPORTANCE_STATE = {
  0: '未填报',
  10: '已驳回',
  20: '已填报',
  30: '已审批',
  40: '已公示',
};